import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" {...props}><path className={styles["st0"] || "st0"} d="M6.8 12h1.5v-1.5H6.8V12zm.7-12C3.4 0 0 3.4 0 7.5S3.4 15 7.5 15 15 11.6 15 7.5 11.6 0 7.5 0zm0 13.5c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM7.5 3c-1.7 0-3 1.3-3 3H6c0-.8.7-1.5 1.5-1.5S9 5.2 9 6c0 1.5-2.3 1.3-2.3 3.8h1.5c0-1.7 2.3-1.9 2.3-3.8 0-1.7-1.3-3-3-3z" /></svg>);